import type { ReactNode } from 'react';
import { useIxcAssetsV1AssetQueryServiceAssetGet } from '@interxfi/api-client/generated/hooks/ixc-assets-v1-asset-query-service-asset-get';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { getShortenedId } from '@interxfi/design-system/components/format/id/shared';
import { Skeleton } from '@interxfi/design-system/components/loading/skeleton';
import { getAssetName } from './utils';

interface AssetBreadcrumbProps {
  assetId: string;
  suffix?: ReactNode;
}

export function AssetBreadcrumb({ assetId, suffix }: AssetBreadcrumbProps) {
  const { data, isPending } = useIxcAssetsV1AssetQueryServiceAssetGet({ assetId });

  if (isPending) {
    return <Skeleton charCount={12} />;
  }

  return (
    <HorizontalStack blockAlign="center" gap={1} wrap="nowrap">
      <span>{getAssetName(data?.asset?.data?.type) || `Asset ${getShortenedId(assetId)}`}</span>
      {suffix}
    </HorizontalStack>
  );
}
